import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * When session expires mid-use, any rendered protected tree should leave for /login.
 * AuthProvider already clears state; this keeps URL in sync.
 */
export function SessionExpiryRedirect() {
  const auth = useAuth();
  const location = useLocation();

  if (
    auth.status === "unauthenticated" &&
    location.pathname !== "/login" &&
    !location.pathname.startsWith("/login")
  ) {
    return <Navigate to="/login" replace />;
  }

  return null;
}
